const AppConstants = {
    CS_KEY: {
        ACCESS_TOKEN: '_szatn',
        REFRESH_TOKEN: '_szatn_ref',
        LOGIN_FIRST_MESSAGE: 'adlf',
        RETURN_URL_AFTER_LOGIN: '_ru_al',
        USER_PROFILE: '_szatn_up',
    },
    SS_KEY: {
        HANDSHAKE_DATA: 'handshakeRes',
    },
    COOKIE_CONFIG: { path: '/', domain: process.env.REACT_APP_ENV === 'local' ? '.shohoz.test' : '.shohoz.com' },
  };

  export default AppConstants;
